export const inbox = {
  noConversations: "No conversations",
};
